import React from 'react'
import ReporteEnTransitoPlayaCalado from '../../../ReporteCamiones/components/ReporteEnTransitoPlayaCalado'
import ReporteProductosCalado from '../../../ReporteCamiones/containers/reportes/ReporteProductosCalado'
import ReporteListosParaBruto from '../../../ReporteCamiones/components/ReporteListosParaBruto'
import ReporteEntreBrutoDestare from '../../../ReporteCamiones/components/ReporteEntreBrutoDestare'

function ReporteProductos (props) {
  const { cpaEntrePlayaCalado, callesDeCalado, camListosParaBruto, camionesCalados, camEntreBrutoDestare } = props

  return (
    <>
      { cpaEntrePlayaCalado && cpaEntrePlayaCalado.length > 0
        ? <div className='card-info-bruto'>
          { props.receiveCpaEntrePlayaCalado
            ? <ReporteEnTransitoPlayaCalado
              cpaEntrePlayaCalado={cpaEntrePlayaCalado}
              dialogOpen={props.dialogOpen}
              cortesPedidos={props.cortesPedidos}
            />
            : <div className='loader-track' style={{ margin: 'auto', opacity: '0.7' }} />
          }
        </div>
        : <></>
      }
      { camionesCalados && camionesCalados.length > 0
        ? <div className='card-info-bruto'>
          {props.receiveCallesDeCalado
            ? <ReporteProductosCalado
              callesDeCalado={callesDeCalado}
              calificacionCalles={props.calificacionCalles}
              camionesCalados={camionesCalados}
              ocupacionCalles={props.ocupacionCalles}
              dialogOpen={props.dialogOpen}
            />
            : <div className='loader-track' style={{ margin: 'auto', opacity: '0.7' }} />
          }
        </div>
        : <></>
      }

      {/* { camListosParaBruto.length > 0 */}
      <div className='card-info-bruto'>
        {props.receiveCamListosParaBruto
          ? <ReporteListosParaBruto
            camListosParaBruto={camListosParaBruto}
            dialogOpen={props.dialogOpen}
          />
          : <div className='loader-track' style={{ margin: 'auto', opacity: '0.7' }} />
        }
      </div>
      {/* : <></>
      } */}

      { camEntreBrutoDestare.length > 0
        ? <div className='card-info-bruto'>
          {props.receiveCamEntreBrutoDestare
            ? <ReporteEntreBrutoDestare
              camEntreBrutoDestare={camEntreBrutoDestare}
              dialogOpen={props.dialogOpen}
            />
            : <div className='loader-track' style={{ margin: 'auto', opacity: '0.7' }} />
          }
        </div>
        : <></>
      }
    </>
  )
}

export default ReporteProductos
